import http from "../http-common";

class MyAssignedTicketsService {

    // get 10 assigned tickets fitting the search criteria (offset based on passed in value)
    getAssignedTickets(offset_value, status, type, assigned_tech_id, priority, search_text, parent_child_filter, sort_order, sort_by, user_id_asking, timezone_adjustment_factor) {
        return http.get(`/myAssignedTickets?offset=${offset_value}&status=${status}&type=${type}&assignedTechId=${assigned_tech_id}&priority=${priority}&searchText=${search_text}&parentChildFilter=${parent_child_filter}&sortOrder=${sort_order}&sortBy=${sort_by}&userIdAsking=${user_id_asking}&timezoneAdjustmentFactor=${timezone_adjustment_factor}`);
    }
}

export default new MyAssignedTicketsService();